// iter180p5 — IST (Asia/Kolkata) display helpers.
//
// Every user-facing date/time MUST render in IST (UTC+05:30), regardless of
// where the browser is. Backend stores UTC ISO strings; this module is the
// single rendering layer.
//
// Use these helpers instead of `new Date(x).toLocaleString()` etc.
//
// Examples (with backend ISO "2026-06-02T19:00:00+00:00" = 00:30 IST on 3 Jun):
//   fmtDateTimeIST("2026-06-02T19:00:00+00:00") → "3 Jun 2026, 12:30 am"
//   fmtDateIST   ("2026-06-02T19:00:00+00:00") → "3 Jun 2026"
//   fmtTimeIST   ("2026-06-02T19:00:00+00:00") → "12:30 am"
//   fmtDateTimeShortIST(...)                   → "03/06/2026, 12:30 am"
//
// Empty / null / invalid input → '—' (consistent placeholder used across UI).

const IST = 'Asia/Kolkata';
const LOCALE = 'en-IN';
const PLACEHOLDER = '—';

const _safe = (iso) => {
  if (iso == null || iso === '') return null;
  const d = iso instanceof Date ? iso : new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d;
};

export const fmtDateTimeIST = (iso) => {
  const d = _safe(iso);
  return d ? d.toLocaleString(LOCALE, { timeZone: IST, dateStyle: 'medium', timeStyle: 'short' }) : PLACEHOLDER;
};

export const fmtDateIST = (iso) => {
  const d = _safe(iso);
  return d ? d.toLocaleDateString(LOCALE, { timeZone: IST, day: 'numeric', month: 'short', year: 'numeric' }) : PLACEHOLDER;
};

export const fmtTimeIST = (iso) => {
  const d = _safe(iso);
  return d ? d.toLocaleTimeString(LOCALE, { timeZone: IST, hour: '2-digit', minute: '2-digit' }) : PLACEHOLDER;
};

export const fmtDateTimeShortIST = (iso) => {
  const d = _safe(iso);
  return d ? d.toLocaleString(LOCALE, { timeZone: IST, dateStyle: 'short', timeStyle: 'short' }) : PLACEHOLDER;
};

// "now" in IST, useful for PDF/Excel "generated at" stamps.
export const nowIST = () => new Date().toLocaleString(LOCALE, { timeZone: IST, dateStyle: 'medium', timeStyle: 'short' });
